import JWT from '@tv2/lib-core/jwt';

/**
 * Get ids from JWT, it not a JWT it will fallback to old ids from the sender.
 * @param {string} token AccessToken.
 * @param {string} fallbackUserId Fallback userId if accessToken is not a JWT.
 */
export default function getIds(
  token: string,
  fallbackUserId: string
): {
  userId?: string;
  adobeId?: string;
  googlePpid?: string;
  authUserId?: string;
  npawId?: string;
} {
  if (JWT.isJWT(token)) {
    const parsedToken = JWT.parse(token) as Record<string, string>;
    const {
      'https://auth.tv2.dk/npaw_id': npawId,
      'https://auth.tv2.dk/adobe_vid': adobeId,
      'https://auth.tv2.dk/google_ppid': googlePpid,
      sub: authUserId,
      'https://auth.tv2.dk/id': userId,
    } = parsedToken;
    return {
      userId,
      adobeId,
      googlePpid,
      authUserId,
      npawId,
    };
  }
  return {
    userId: fallbackUserId,
  };
}
